import { useCreateTerminKalenderFormContext } from '@/domain/termine/features/CreateTerminKalender/shared/CreateTerminKalenderFormContext';
import { useTranslation } from 'react-i18next';

export function InputFormField() {
  const { t } = useTranslation();
  const form = useCreateTerminKalenderFormContext();

  return (
    <form.AppField name="titel">
      {(field) => (
        <field.TextInput
          label={t('domain.termine.sheet.fields.titel')}
          isRequired
        />
      )}
    </form.AppField>
  );
}
